<script>
import { Toast } from '@ks/sharp-ui';
import { COMPONENT_MAP, SIMPLE_COMPONENT } from '../register';
import ComponentConfig from '../classes/component-config';
import ComponentBase from '../component-base';
import { component } from './props';

export default {
    name: component,
    components: {
        // 为避免组件间循环引用采用异步加载
        MobileGeneralFormArray: () => import('../mobile-general-form-array'),
        ...SIMPLE_COMPONENT,
    },
    extends: ComponentBase,
    computed: {
        output() {
            return this.config.output || '';
        },
    },
    methods: {
        // 举报中台出现了只提交局部数据的需求
        async submitSelfData() {
            if (await this.validate()) {
                // 自身数据合法
                this.formRoot.$emit(
                    'submit-container-valid',
                    this.getSelfFormDataValue(),
                    this.config,
                );
            }
        },
        /**
         * 以下是组件公共方法的实现
         */
        async validate() {
            if (this.skipValidate()) {
                return true;
            }
            let res = true;
            for (const index in this.$refs.children) {
                try {
                    res &= await this.$refs.children[index].validate();
                } catch (e) {
                    res = false;
                }
            }
            if (!res) {
                this.toastAndLog('请修改标红信息');
            }
            return res;
        },
        clearValidate() {
            for (const index in this.$refs.children) {
                this.$refs.children[index].clearValidate();
            }
        },
    },
    render(h) {
        let hintNode;
        if (this.props.hint) {
            hintNode = h('span', {
                class: 'hint',
            },
            this.i18n(this.props.hint));
        } else {
            hintNode = h();
        }

        const titleNode = h('div', {
            class: `${component}-title`,
            directives: [
                {
                    name: 'show',
                    value: this.props.hideTitle !== true,
                },
            ],
        }, [this.i18nLabel, hintNode]);
        let children = [
            titleNode,
            ...(this.props.children || []).map((childConfig, index) => {
                // 处理配置，如果没有uuid则分配一个
                const uuidFallback = `${this.uuid}_${index}`;
                const compConfig = new ComponentConfig(childConfig, { uuidFallback });
                const childComponent = COMPONENT_MAP[compConfig.component];
                if (childComponent) {
                    return h(childComponent, {
                        props: {
                            originConfig: compConfig,
                            parentOutputPath: this.outputPath,
                        },
                        ref: 'children',
                        refInFor: true,
                    });
                }
                return h();
            }),
        ];
        const lastChild = this.props.children[this.props.children.length - 1];
        const isBtn = lastChild.component === 'mobile-general-form-button';
        if (isBtn) {
            const btn = children.pop();
            const divs = h('div', {
                class: 'other',
            }, children);
            children = [divs, btn];
        }
        return h('section', {
            class: `${component} uuid-${this.config.uuid}`,
            directives: [
                {
                    name: 'show',
                    value: this.props.hide !== true,
                },
            ],
        }, children);
    },
};
</script>
<style lang="less" scoped>
.mobile-general-form-container {
    &-title {
        margin: 0;
        font-size: 16px;
        height: 56px;
        font-weight: 400;
        line-height: 56px;
        text-indent: 16px;
        color: #777;
        & > .hint {
            font-size: 12px;
            margin-left: 16px;
        }
    }
}
</style>
